export default __webpack_public_path__ + "static/media/skydive-wellies.40998ddd.jpg";